function r(t, e) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
export {
  r as default
};
